import { capitalizeString } from "@utils/utils";
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import { Paragraph, Small } from "@fronterahealth/frontera-ui-components";

import { ApiReportSectionsAiGeneratedStatusChoices } from "@api/graphql/types-and-hooks";
import { useScrollToAnchor } from "@pages/ClinicalReportDetails/Components/StickyNav/useScrollToAnchor";

interface HeadingItemInterface {
  heading: string;
  hash: string;
  sections: SectionProps[];
}
const HeadingItem: React.FC<HeadingItemInterface> = ({ heading, hash }) => {
  const actualHeading = heading.split(/-(.+)/)[1]; // split by first occurrence of "-"
  const active = hash.replace("#", "") === heading;
  const headingLabel = actualHeading
    .split("-")
    .map((h) => capitalizeString(h))
    .join(" ");

  return (
    <Link to={`#${heading}`} key={heading}>
      <div
        className={`transition-all cursor-pointer ${active ? "border-l-2" : "border-l"}   py-2 pl-2 hover:border-interaction-primary  ${active ? "border-interaction-primary" : "border-limestone-100"} `}
      >
        <div className="flex items-center">
          <Small
            className={`transition-all hover:text-text-primary`}
            displayType={active ? "loud" : "normal"}
            colorType={active ? "primary" : "secondary"}
          >
            {headingLabel}
          </Small>
        </div>
      </div>
    </Link>
  );
};

interface SectionProps {
  title: string;
  aiGeneratedStatus: ApiReportSectionsAiGeneratedStatusChoices;
}

interface StickyNavProps {
  sections: SectionProps[];
  maxHeight?: string;
}

/**
 * BACKPORT-FINAL: To be used going forward
 * This is the floating nav item bar that reads and scans for any div elements with the "data-sticky-nav-header" data attribute
 * on them and renders them as clickable legend elements that will jump the user to that section
 * @returns
 */
export const StickyNav: React.FC<StickyNavProps> = ({ sections, maxHeight = "max-h-[calc(100vh-335px)]" }) => {
  const { hash } = useLocation();
  const [headings, setHeadings] = React.useState<string[]>([]);

  useEffect(() => {
    const _headings = Array.from(document.querySelectorAll(`[data-sticky-nav-header]`)).map((div) => div.id);
    setHeadings(_headings);
  }, [sections]);

  useScrollToAnchor();

  return (
    <nav className="sticky top-14 flex flex-col items-start ">
      <Paragraph className="mb-2">On this page</Paragraph>
      <div className={`flex flex-col items-start ${maxHeight} overflow-y-scroll `}>
        {headings.map((heading) => (
          <HeadingItem key={heading} heading={heading} hash={hash} sections={sections} />
        ))}
      </div>
    </nav>
  );
};
